const STORE_COLORS = {
  PRIMARY_MAIN: '#1D1D1D',
  PRIMARY_CONTRAST: '#1D1D1D',
  SECONDARY_MAIN: '#1D1D1D',
  BACKGROUND: '#FFFFFF',
}

export { STORE_COLORS }
